import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { DeleteProjectHistoryAPI, GetAllProjectHistoryAPI } from "../../../API/ProjectHistoryAPI";
import useModal from "../../../Hooks/useModal";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { ProjectHistoryModel } from "../../../Models/ProjectHistoryModel";
import { ProjectHistoryColumns } from "../../../Static/ProjectHistoryColumns";
import ModalProjectHistory from "../../ModalProjectHistory";
import TableDefault from "../../Shared/TableDefault";
import ModalValuesHistoryComponent from "../ModalValuesHistoryComponent";
import './styles.css';
import { Button } from "@mui/material";

interface IProjectsHistoryComponentProps {
    companyId: string,
    toggleLoading: (data: boolean) => void,
    setHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    canNotEdit: boolean
}

const ProjectHistoryComponent = (props: IProjectsHistoryComponentProps) => {
    const { showModal, toggleShowModal } = useModal();
    const [ total, setTotal ] = useState<number>(0);
    const [ projects, setProjects ] = useState<ProjectHistoryModel[]>([]);
    const [ project, setProject ] = useState<ProjectHistoryModel>({} as ProjectHistoryModel);
    const { showModal: showModalProject, toggleShowModal: toggleShowModalProject } = useModal();

    const navigate = useNavigate();

    const getAllProjectsHistory = async (page?: number) => {
        try {
            props.toggleLoading(true);
            let text = "all"

            await GetAllProjectHistoryAPI(props.companyId, page ?? 1, 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setProjects(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const DeleteProjectHistory = async (projectId: string) => {
        try {
            props.toggleLoading(true);

            await DeleteProjectHistoryAPI(projectId, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    getAllProjectsHistory();
                    props.setHasChanged(true);
                }
            }).finally(() => {
                props.toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    const navigateToCreate = () => {
        const route = `/projectInformation/createProjectHistory/${props.companyId}`;

        navigate(route);
    }

    const showValuesOnModal = (project: ProjectHistoryModel) => {
        setProject(project);
        toggleShowModal()
    }

    const setModalProject = (project: ProjectHistoryModel) => {
        setProject(project);
    }

    useEffect(() => {
        getAllProjectsHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ props.companyId ]);

    return (
        <div className="mt-4">
            {project.id && <ModalValuesHistoryComponent show={showModal} toggleShow={toggleShowModal} project={project} />}
            <ModalProjectHistory
                showModal={showModalProject}
                toggleShowModal={toggleShowModalProject}
                projectItem={project}
            />
            {/* <PaginationTabHeader setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={columns} /> */}
            <div className="container-table">
                <TableDefault
                    hasModalInfo={true}
                    setModalInfo={setModalProject}
                    toggleShowModalInfo={toggleShowModalProject}
                    hasHeader={true}
                    firstColumnIsLink={!props.canNotEdit}
                    columns={ProjectHistoryColumns}
                    lastColumnIsAction={!props.canNotEdit}
                    rows={projects}
                    linkToFirstColumn={`/recommendations/ProjectLines/${props.companyId}/`}
                    total={total}
                    changePage={getAllProjectsHistory}
                    linkToEdit={`/projectInformation/editProjectHistory/`}
                    functionToDelete={DeleteProjectHistory}
                    ColumnWithButton={2}
                    columnActionToButton={showValuesOnModal}
                    hasDelete={true}
                    hasEdit={true}
                    hasPagination={true}
                    isProjectInformation={true}
                />
                {!props.canNotEdit &&
                    <Button variant="contained" className="btn btn-primary w-100" onClick={navigateToCreate}>
                        Criar Historico de projeto
                    </Button>
                }
            </div>
        </div>
    )
}

export default ProjectHistoryComponent;